// Counter animation targets and increments
export const COUNTER_CONFIG = {
  widowsHelped: { target: 650, increment: 13 },
  homesRepaired: { target: 320, increment: 8 },
  carsServiced: { target: 480, increment: 12 },
  animationInterval: 40, // milliseconds
};

// Donation amounts
export const QUICK_DONATION_AMOUNTS = [25, 50, 100, 250];

// Navigation items
export const NAV_ITEMS = [
  "home",
  "impact",
  "about",
  "stories",
  "donate",
  "contact",
];

// Scroll behavior
export const SCROLL_CONFIG = {
  headerOffset: 80, // Height of fixed header + buffer
  behavior: "smooth",
};

// Contact information
export const CONTACT_INFO = {
  email: "info@compassionforwidows.org",
  phone: "+1 (555) 123-4567",
  address: {
    street: "123 Hope Street",
    city: "Compassion City, CC 12345",
  },
};
